// Should stay in sync with systemRoles.mjs
export const VIP_PORTAL_ADMIN = 1;
export const VIP_PARTNER = 2;
export const FDA_ADMIN = 3;
export const FDA_REVIEWER = 4;
export const ORG_SPONSOR = 5;
export const ORG_COORDINATOR = 6;
export const ORG_UNIT_SPONSOR = 8;
export const ORG_UNIT_COORDINATOR = 9;
export const ISACA_MDDAP_APPRAISER = 10;
export const VIP_FREE_LICENSE = 11;
export const INTERNAL_ATM = 12;
